import Layout from '@/components/feature/Layout';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Categories from './components/Categories';
import ComicSection from './components/ComicSection';
import Cta from './components/Cta';
import Faq from './components/Faq';
import { newReleases, completedComics } from '@/mocks/comics';

export default function HomePage() {
  return (
    <Layout>
      <Hero />
      <Ranking />
      <Categories />
      <ComicSection
        title="新上架作品"
        desc="近期最新收录的连载佳作，抢先追更不落后。"
        icon="ri-sparkling-2-line"
        list={newReleases}
        linkText="浏览新上架"
        linkTo="/comics?sort=new"
      />
      <ComicSection
        title="完结作品库"
        desc="已更新完整本故事，一口气读完的畅快体验。"
        icon="ri-check-double-line"
        list={completedComics}
        linkText="进入完结作品库"
        linkTo="/comics?sort=completed"
        bg="tint"
      />
      <Cta />
      <Faq />
    </Layout>
  );
}